import classNames from 'classnames';
import React, { CSSProperties, forwardRef } from 'react';

import styles from './Action.module.scss';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  active?: {
    fill: string;
    background: string;
  };
  cursor?: CSSProperties['cursor'];
}

export const Action = forwardRef<HTMLButtonElement, Props>(
  ({ active, className, cursor = 'pointer', style, ...props }, ref) =>
  (
    <button
      ref={ref}
      type='button'
      {...props}
      className={classNames(styles.Action, className)}
      tabIndex={0}
      style={
        {
          ...style,
          cursor,
          '--fill': active?.fill,
          '--background': active?.background,
        } as CSSProperties
      }
    />
  )
);

Action.defaultProps = {
  active: undefined,
  cursor: undefined,
};